import { Component, OnInit } from '@angular/core';
import { ClaimModel } from '../../models/role.model';
import { StorageService } from '../../services/storage.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { site } from '../../../global';
import { RoleType } from '../../models/user.model';
import { ClaimsService } from '../../services/claims.service';
import { MultiDeviceInteractionState } from '../../models/consumer/consumer-interaction.model';

@Component({
    selector: 'navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {

    routes: any[]
    claims: ClaimModel[];
    clientId: number;
    subscriptions: Subscription[] = [];
    isSuperuser: boolean = false;
    isAdmin: boolean = false;
    isPayg: boolean = false;
    isBilling: boolean = false;
    isMetering: boolean = false;
    isPaygUpdate: boolean = false;
    version = site.VERSION;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private storageService: StorageService,
        private claimsService: ClaimsService
    ) { }

    ngOnInit() {
        try {           
            this.isSuperuser = this.claimsService.isSuperUser();
            this.isAdmin = this.claimsService.isAdmin();
            this.isPayg = this.claimsService.hasPaygFeature();
            this.isPaygUpdate = this.claimsService.hasPaygUpdateFeature();
            this.isBilling = this.claimsService.hasBillingFeature();
            this.isMetering = this.claimsService.hasConsumptionFeature();
        } catch {
        }

    this.subscriptions.push(this.route
      .params
      .subscribe(params => {
        this.clientId = +params['clientId'];
        if (!this.clientId) { this.clientId = parseFloat(this.storageService.getItem("client")); } // if don't have client id then get from storage
        this.createRoutes();
      }));
        this.createRoutes();
    }

    createRoutes() {
        this.routes = [];

        let component = this.router.routerState.snapshot.url.split('/');

        if (component.length > 2 && component[2].toLocaleUpperCase().includes("ADMIN")) this.clientId = parseFloat(this.storageService.getItem("client"));
        if (component.length > 2 && component[2].toLocaleUpperCase().includes("ROADMAP")) this.clientId = parseFloat(this.storageService.getItem("client"));
        this.routes = [
            {
                name: 'Dashboard',
                route: ["/portal/" + this.clientId.toString(), "dashboard"],
                svg: "#ic-dashboard",
                isClicked: component[3] && component[3].toLocaleUpperCase().includes("DASHBOARD") ? true : false,
                isAuthorized: !this.isAdmin
            },
            {
                name: 'Consumer search',
                route: ["/portal/" + this.clientId.toString(), "consumers"],
                svg: "#ic-consumer-search",
                isClicked: component[3] && component[3].toLocaleUpperCase().includes("CONSUMERS") ? true : false,
                isAuthorized: !this.isAdmin
            },
            {
                name: 'PAYG Portfolio',
                route: ["/portal/" + this.clientId.toString(), "portfolio"],
                svg: "#ic-payg",
                isClicked: component[3] && component[3].toLocaleUpperCase().includes("PORTFOLIO") ? true : false,
                isAuthorized: this.isSuperuser || this.isPayg
            },
            {
                name: 'Billing Portfolio',
                route: ["/portal/" + this.clientId.toString(), "billing"],
                svg: "#ic-billing",
                isClicked: component[3] && component[3].toLocaleUpperCase().includes("BILLING") ? true : false,
                isAuthorized: this.isSuperuser || this.isBilling
            },
            {
                name: 'Meter Portfolio',
                route: ["/portal/" + this.clientId.toString(), "meter"],
                svg: "#ic-consumption",
                isClicked: component[3] && component[3].toLocaleUpperCase().includes("METER") ? true : false,
                isAuthorized: this.isSuperuser || this.isMetering
            },
            //{
            //    name: 'Multi-Device Management',
            //    route: ["/portal/" + this.clientId.toString(), "multideviceinteractions", "create"],
            //    queryParams: { 'state': MultiDeviceInteractionState.what },
            //    svg: "#ic-multi-device",
            //    isClicked: component[3] && component[3].toLocaleUpperCase().includes("MULTIDEVICEINTERACTIONS") ? true : false,
            //    isAuthorized: this.isPayg || this.isPaygUpdate
            //},
            //{
            //    name: 'Device Interactions',
            //    route: ["/portal/" + this.clientId.toString(), "deviceinteractions"],
            //    svg: "#ic-bell",
            //    isClicked: component[3] && component[3].toLocaleUpperCase().includes("DEVICEINTERACTIONS") ? true : false,
            //    isAuthorized: this.isSuperuser || this.isPaygUpdate
            //},
            {
                name: 'Issues',
                route: ["/portal/" + this.clientId.toString(), "issues"],
                svg: "#ic-issues",
                isClicked: component[3] && component[3].toLocaleUpperCase().includes("ISSUES") ? true : false,
                isAuthorized: !this.isAdmin
            },
            {
                name: 'Account',
                route: ["/portal/account/me"],
                svg: "#ic-account",
                isClicked: component[3] && component[3].toLocaleUpperCase().localeCompare("ME") == 0 ? true : false,
                isAuthorized: true
            }        
        ];

        if (this.isAdmin || this.isSuperuser) {
            this.routes.push(
                {
                    name: 'Admin',
                    route: ["/portal/admin"],
                    svg: "#ic-user-admin",
                    isClicked: component[2] && component[2].toLocaleUpperCase().includes("ADMIN") ? true : false,
                    isAuthorized: true
                }
            );
        }

        this.routes.push(
            {
                name: 'Log Out',
                route: ["/auth", "logout"],
                svg: "#ic-logout",
                isAuthorized: true
            }
        );
    }

    onClick(index: number) {
        for (let i = 0; i < this.routes.length; i++) {
            this.routes[i].isClicked = false;
        }
        this.routes[index].isClicked = true;
    }
}
